module.exports = __webpack_public_path__ + "static/img/SupandSerd.50b3bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SupandSerd.png
// module id = B2DI
// module chunks = 1